import { render, staticRenderFns } from "./dyt-page.vue?vue&type=template&id=fabbe7b4&"
import script from "./dyt-page.vue?vue&type=script&lang=js&"
export * from "./dyt-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports